<div>
    <form action="" class="bg-brand-purple-50 py-12 px-6">
        <h2 class="text-center page-title">O que está procurando?</h2>
        <div class="flex gap-2 max-w-36rem mx-auto mt-6 flex-wrap">
            <label class="flex flex-1 basis-1-2">
                <span class="sr-only">Tipo de localização</span>
                <ng-select 
                    [items]="abrangencia" 
                    [(ngModel)]="abrangenciaSelecionada" 
                    name="abrangenciaSelecionada"
                    [multiple]="false" 
                    [searchable]="false" 
                    placeholder="Abrangência"
                    [clearable]="false"
                    bindLabel="chave" bindValue="valor" 
                    [clearOnBackspace]="false"
                    class="form-select select-abrangencia input-dashboard" 
                    [closeOnSelect]="true" 
                    [disabled]="!permissaoService.hasPermissionComponente(1)"
                    [title]="permissaoService.hasPermissionComponente(1) ? 'Abrangência' : 'Você não tem permissão para acessar esta funcionalidade'"
                    [loading]="carregandoAbrangencia" loadingText="Carregando abrangência..." notFoundText="Nenhuma abrangência encontrada"                    
                >
                </ng-select>
            </label>

            <label class="flex basis-0  flex-1 grow" *ngIf="false">
                <input type="text" class="form-input input-dashboard" placeholder="Secretaria"
                    [(ngModel)]="termoPesquisa" name="termoPesquisa" [disabled]="!permissaoService.hasPermissionComponente(1) || buscandoOportunidades"
                    [title]="permissaoService.hasPermissionComponente(1) ? 'Orgão' : 'Você não tem permissão para acessar esta funcionalidade'">
            </label>

            <button type="button" class="form-button flex-1 basis-1-2 input-dashboard" (click)="buscarOportunidades()"
                [disabled]="buscandoOportunidades || !permissaoService.hasPermissionComponente(1)"
                [title]="permissaoService.hasPermissionComponente(1) ? 'Buscar oportunidades' : 'Você não tem permissão para acessar esta funcionalidade'">
                <p *ngIf="!buscandoOportunidades">Buscar oportunidades</p>
                <app-carregando [showCarregando]="buscandoOportunidades" [isChart]="false" />
            </button>
        </div>
    </form>
    <div class="main-content__area">
        <div class="novidades py-5" *ngIf="!carregandoNovidades && novidades.length > 0">
            <h2 class="page-title text-center">Novidades na Plataforma</h2>
            <div class="grid grid-cols-2 md:grid-cols-3 gap-6 max-w-5xl mx-auto mt-6"></div>
            <div class="swiper">
                <swiper-container #swiper [config]="swiperParams">
                    <swiper-slide *ngFor="let novidade of novidades">
                        <div
                            class="bg-white shadow-outer [&]:p-5 text-brand-gray-400 rounded-lg container-novidade">
                            <a href="#" (click)="selecionarNovidade(novidade); $event.preventDefault()"
                                data-bs-toggle="modal" data-bs-target="#modalNovidade"
                                class="space-y-4">
                                <div class="image-wrapper flex-shrink-0">
                                    <img [src]="novidade.imagem" [alt]="novidade.titulo">
                                </div>
                                <div class="flex flex-col flex-grow">
                                    <h3 class="text-sm font-medium line-clamp-2">{{novidade.titulo}}</h3>
                                    <p class="text-xs">{{novidade.dataPublicacao | date:'dd/MM/yyyy'}}</p>
                                </div>
                            </a>
                        </div>
                    </swiper-slide>
                </swiper-container>
                <div class="swiper-buttons-wrapper">
                    <div class="swiper-button swiper-button-prev" [class.swiper-button-disabled]="!podeNavegarAnterior()"
                        (click)="anteriorSlide()" role="button" aria-label="Novidade anterior">
                    </div>
                    <div class="swiper-button swiper-button-next" [class.swiper-button-disabled]="!podeNavegarProximo()"
                        (click)="proximoSlide()" role="button" aria-label="Próxima novidade">
                    </div>
                </div>
            </div>
        </div>
        <app-carregando [showCarregando]="carregandoNovidades" [isChart]="false" containerHeight="312px"
            spinnerSize="48px">
        </app-carregando>

        <div class="text-center py-5" *ngIf="!carregandoNovidades && novidades.length === 0">
            <p class="text-brand-gray-400">Não existem novidades disponíveis no momento.</p>
        </div>
    </div>
</div>

<!-- Modal -->
<app-modal-sem-creditos
  [mostrarModal]="mostrarModalSemCreditos"
  (fecharModalEvent)="fecharModalSemCreditos()">
</app-modal-sem-creditos>

<app-modal-boas-vindas
  [mostrarModal]="mostrarModalBoasVindas"
  (fecharModalEvent)="fecharModalBoasVindas()">
</app-modal-boas-vindas>

<div class="modal fade" id="modalNovidade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">{{novidadeSelecionada?.titulo}}</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="fecharModal()"></button>
            </div>
            <div class="modal-body">
                <div class="grid grid-cols-5 gap-x-10">
                    <div class="col-span-2">
                        <div class="image-wrapper">
                            <img [src]="novidadeSelecionada?.imagem" [alt]="novidadeSelecionada?.titulo">
                        </div>
                    </div>
                    <div class="col-span-3 text-sm space-y-5">
                        <p>{{novidadeSelecionada?.mensagem}}</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer flex items-center justify-between">
                <p class="text-xs">
                    Publicado em {{novidadeSelecionada?.dataPublicacao | date:'dd/MM/yy'}}
                </p>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" *appTemPermissao="EnumPermissao.FazerSegmentacao"
                    (click)="visualizarOportunidades(novidadeSelecionada?.filtro)">Visualizar oportunidades</button>
            </div>
        </div>
    </div>
</div>